import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthProvider } from '@shared/auth/AuthContext'
import { TrialExpirationProvider } from '@shared/contexts/TrialExpirationContext'

// Suppress noisy browser warnings that don't affect functionality
const originalWarn = console.warn
const originalError = console.error

console.warn = (...args: any[]) => {
  const message = args.join(' ')

  // Suppress Stripe tracking prevention warnings (browser privacy features blocking Stripe's fraud detection)
  if (message.includes('Tracking Prevention') && message.includes('stripe')) {
    return
  }

  originalWarn.apply(console, args)
}

console.error = (...args: any[]) => {
  const message = args.join(' ')

  // Suppress Stripe tracking prevention errors (browser privacy features blocking Stripe iframes)
  if (message.includes('Tracking Prevention') && (message.includes('stripe') || message.includes('m.stripe.network'))) {
    return
  }

  originalError.apply(console, args)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <TrialExpirationProvider>
        <App />
      </TrialExpirationProvider>
    </AuthProvider>
  </React.StrictMode>
)